/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
export var FeedbackType = {
    Error: "error",
    Success: "success"
};
